import { render, staticRenderFns } from "./TermAndConditions.vue?vue&type=template&id=08c14195&scoped=true&"
import script from "./TermAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermAndConditions.vue?vue&type=style&index=0&id=08c14195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c14195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
